document.addEventListener('DOMContentLoaded', function () {
    const headers = document.querySelectorAll('.product-ingredients-community___accordion-list-item-header');

    headers.forEach((header) => {
        header.addEventListener('click', function () {
            const content = header.nextElementSibling;
            const isOpen = header.classList.contains('active');

            // Close any other open accordion items
            document.querySelectorAll('.product-ingredients-community___accordion-list-item-header.active').forEach((activeHeader) => {
                if (activeHeader !== header) {
                    closeAccordion(activeHeader, activeHeader.nextElementSibling);
                }
            });

            // Toggle the clicked item
            if (isOpen) {
                closeAccordion(header, content);
            } else {
                openAccordion(header, content);
            }
        });
    });

    function openAccordion(header, content) {
        header.classList.add('active');
        // Set the height to the scrollHeight to animate opening
        content.style.height = content.scrollHeight + 'px';

        // When the transition ends, remove the inline height if open so it can adapt if content changes.
        content.addEventListener('transitionend', function handler(e) {
            if (e.propertyName === 'height' && header.classList.contains('active')) {
                content.style.height = 'auto';
            }
            content.removeEventListener('transitionend', handler);
        });
    }

    function closeAccordion(header, content) {
        header.classList.remove('active');

        // For a smooth close, if the height is 'auto' we first set it to the current pixel height.
        if (content.style.height === 'auto') {
            content.style.height = content.scrollHeight + 'px';
            // Force reflow to apply the new fixed height
            content.offsetHeight;
        }
        // Then animate to 0
        content.style.height = '0px';
    }

    const mediaSection = document.querySelector('.product-ingredients-community___media');
    const storiesEl = document.querySelector('tolstoy-stories');

    if (!storiesEl || !mediaSection) return;

    // helper to hide when status is notFound
    const checkAndHide = () => {
        if (storiesEl.getAttribute('data-status') === 'notFound') {
            mediaSection.style.display = 'none';
            observer.disconnect(); // stop observing once hidden
        }
    };

    // initial check in case the attribute is already set
    checkAndHide();

    // watch for changes to data-status
    const observer = new MutationObserver(checkAndHide);
    observer.observe(storiesEl, {
        attributes: true,
        attributeFilter: ['data-status'],
    });
});
